import { App } from 'vue'
import List from './LpList.vue'

List.install = (Vue: App) => {
  Vue.component(List.name, List)
}

export default List
